import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PredictionCard = ({ prediction, onAddToWatchlist, onSetAlert }) => {
  const getConfidenceColor = (confidence) => {
    if (confidence >= 80) return 'text-success';
    if (confidence >= 60) return 'text-warning';
    return 'text-error';
  };

  const getRiskColor = (risk) => {
    if (risk === 'Low') return 'text-success';
    if (risk === 'Medium') return 'text-warning';
    return 'text-error';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-2">
      <div className="flex items-start justify-between mb-6">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-lg">{prediction?.symbol?.slice(0, 2)}</span>
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-card-foreground">{prediction?.name}</h2>
            <p className="text-muted-foreground">{prediction?.symbol}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="text-2xl font-bold text-card-foreground">${prediction?.currentPrice?.toLocaleString()}</p>
          <p className={`text-sm ${prediction?.change24h >= 0 ? 'text-success' : 'text-error'}`}>
            {prediction?.change24h >= 0 ? '+' : ''}{prediction?.change24h?.toFixed(2)}% (24h)
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Brain" size={20} className="text-primary" />
            <span className="text-sm font-medium text-muted-foreground">AI Confidence</span>
          </div>
          <p className={`text-2xl font-bold ${getConfidenceColor(prediction?.confidence)}`}>
            {prediction?.confidence}%
          </p>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Target" size={20} className="text-primary" />
            <span className="text-sm font-medium text-muted-foreground">Price Target</span>
          </div>
          <p className="text-2xl font-bold text-card-foreground">
            ${prediction?.priceTarget?.toLocaleString()}
          </p>
          <p className="text-sm text-muted-foreground">
            Range: ${prediction?.targetRange?.min?.toLocaleString()} - ${prediction?.targetRange?.max?.toLocaleString()}
          </p>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Clock" size={20} className="text-primary" />
            <span className="text-sm font-medium text-muted-foreground">Timeframe</span>
          </div>
          <p className="text-2xl font-bold text-card-foreground">{prediction?.timeframe}</p>
          <p className={`text-sm ${getRiskColor(prediction?.riskLevel)}`}>
            Risk: {prediction?.riskLevel}
          </p>
        </div>
      </div>
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-card-foreground mb-3">Prediction Analysis</h3>
        <p className="text-muted-foreground leading-relaxed">{prediction?.analysis}</p>
      </div>
      <div className="flex flex-wrap gap-3">
        <Button 
          variant="default" 
          iconName="Bell" 
          iconPosition="left"
          onClick={() => onSetAlert(prediction)}
        >
          Set Price Alert
        </Button>
        <Button 
          variant="outline" 
          iconName="Plus" 
          iconPosition="left"
          onClick={() => onAddToWatchlist(prediction)}
        >
          Add to Watchlist
        </Button>
        <Button variant="ghost" iconName="Share" iconPosition="left">
          Share Prediction
        </Button>
      </div>
    </div>
  );
};

export default PredictionCard;